module.exports = __webpack_public_path__ + "static/vascepa-logo-f004365ed0f4b52a2e31a0eb48dece28.svg";